import { Directive, Inject, Input } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import moment from 'moment';
import { CustomMomentDateAdapter } from 'src/app/models/customMomentDateAdapter';

const dateFormats = ['MMM-DD-YYYY', 'MM/DD/YYYY', 'MM-DD-YYYY', 'MMM-YYYY', 'MM-YYYY'];

export class FtuDateAdapter extends CustomMomentDateAdapter {
  override parse(value: unknown, parseFormat: string | string[]): moment.Moment | null {
    if (typeof value === 'string') {
      const format = Array.isArray(parseFormat) ? parseFormat[0] : parseFormat;
      const input = value.trim();
      if (/^\d{8}$/.test(input) && (format === 'MM/DD/YYYY' || format === 'MM-DD-YYYY')) {
        return moment(input, 'MMDDYYYY', true);
      }
      return moment(input, format, true);
    }
    return super.parse(value, parseFormat);
  }
}

@Directive({
  selector: 'input[appFtuDateFormat]',
  providers: [
    { provide: DateAdapter, useClass: FtuDateAdapter, deps: [MAT_DATE_LOCALE] },
    {
      provide: MAT_DATE_FORMATS,
      useFactory: (): MatDateFormats => ({
        parse: { dateInput: 'MMM-DD-YYYY' },
        display: {
          dateInput: 'MMM-DD-YYYY',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'll',
          monthYearA11yLabel: 'MMM YYYY'
        }
      })
    }
  ]
})
export class FtuDateFormatDirective {
  @Input() set appFtuDateFormat(value: string | null | undefined) {
    const format = dateFormats.find(candidate => value?.includes(candidate)) || 'MMM-DD-YYYY';
    this.formats.parse.dateInput = format;
    this.formats.display.dateInput = format;
  }

  constructor(@Inject(MAT_DATE_FORMATS) private formats: MatDateFormats) { }
}